<template>
  <a-modal
    title="Check company by NIP"
    :visible="isVisible"
    :width="900"
    @cancel="handlerClose"
    :footer="null"
  >
    <div id="Home__page">
      <a-steps :current="HomeStep">
        <a-step :title="$t('Search a company by NIP')" />
        <a-step :title="$t('Check and edit the imported data')" />
        <a-step :title="$t('Save data company')" />
      </a-steps>
      <FirstStep v-if="HomeStep == 0" :defaultNip="defaultNip" />
      <SecondStep v-else-if="HomeStep == 1" />
      <ThirdStep v-else @handlerClose="handlerClose" />
    </div>
  </a-modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import searchForm from "@/components/integrationNip/searchForm";
import companyCardForm from "@/components/integrationNip/companyCardForm";
import finish from "@/components/integrationNip/finish";
export default {
  props: ["defaultNip"],
  components: {
    FirstStep: searchForm,
    SecondStep: companyCardForm,
    ThirdStep: finish,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: mapGetters(["HomeStep", "FormData"]),
  methods: {
    ...mapActions(["ResetStep"]),
    showModal() {
      this.isVisible = true;
    },
    handlerClose() {
      this.isVisible = false;
      this.ResetStep();
      if (this.FormData.result)
        this.$emit("handlerNipClose", this.FormData.result.id);
    },
  },
};
</script>